/** Central route table. Use these helpers instead of hardcoding paths. */
export const ROUTES = {
  home: '/',
  about: '/about',
  article: (slug = ':slug') => `/articles/${slug}`,
  auth: '/auth',
  authCallback: '/auth/callback',
  profile: '/profile',
  write: '/write',
  writeArticle: (id = ':id') => `/write/${id}`,
  admin: '/admin',
  adminArticles: '/admin/articles',
  adminWriters: '/admin/writers',
  adminSubscribers: '/admin/subscribers',
  adminSettings: '/admin/settings',
  subscribeConfirm: '/subscribe/confirm',
  unsubscribe: '/unsubscribe',
  inviteAccept: '/invite/accept',
} as const;
